import React from "react";
import PropTypes from "prop-types";
import { STOCK_STATUSES } from "./stockStatus";
import "../../css/search.css";

export default function SearchFilters({
  availableStatuses,
  selectedStatuses,
  onToggleStatus,
  abandonedCount,
  showAbandoned,
  onToggleAbandoned,
}) {
  if (!availableStatuses.length && abandonedCount === 0) {
    return null;
  }

  return (
    <div className="search-filters" role="group" aria-label="Filtres de recherche">
      {availableStatuses.map((statusId) => {
        const meta = STOCK_STATUSES.find((s) => s.id === statusId);
        if (!meta) return null;
        const active = selectedStatuses.includes(statusId);

        return (
          <button
            key={statusId}
            type="button"
            className={`filter-chip${active ? " is-active" : ""}`}
            style={{
              "--chip-color": meta.color,
            }}
            aria-pressed={active}
            onClick={() => onToggleStatus(statusId)}
          >
            <span
              className="filter-chip-dot"
              style={{ background: meta.color }}
              aria-hidden="true"
            />
            {meta.label}
          </button>
        );
      })}

      {abandonedCount > 0 && (
        <button
          type="button"
          className={`filter-chip filter-chip-abandoned${showAbandoned ? " is-active" : ""}`}
          aria-pressed={showAbandoned}
          title={
            showAbandoned
              ? "Masquer les produits abandonnés"
              : "Afficher les produits abandonnés"
          }
          onClick={onToggleAbandoned}
        >
          <span className="filter-chip-dot" aria-hidden="true" />
          ABANDONNE
          <span className="filter-chip-count">{abandonedCount}</span>
        </button>
      )}
    </div>
  );
}

SearchFilters.propTypes = {
  availableStatuses: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectedStatuses: PropTypes.arrayOf(PropTypes.number).isRequired,
  onToggleStatus: PropTypes.func.isRequired,
  abandonedCount: PropTypes.number.isRequired,
  showAbandoned: PropTypes.bool.isRequired,
  onToggleAbandoned: PropTypes.func.isRequired,
};
